import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Tabs } from 'antd';
import ConditionsPrompts from './ConditionsPrompts';
import MagicflowPrompts from './MagicflowPrompts';
import ServiceRequestsPrompts from './ServiceRequestsPrompts';
import AgentsPrompts from './AgentsPrompts';
import { setActiveSubTabAction } from 'src/modules/SuperAdmin/store/actions/superadmin.action';

const PromptsWrapper = () => {
  const dispatch = useDispatch();
  const { activeSubTab } = useSelector((state) => state?.superadminState || {});

  const handleTabChange = (newTab) => {
    dispatch(setActiveSubTabAction(newTab));
  };

  const tabItems = [
    {
      key: 'Specialties',
      label: 'Specialties',
      children: <ConditionsPrompts />,
    },
    {
      key: 'Service Requests',
      label: 'Service Requests',
      children: <ServiceRequestsPrompts />,
    },
    {
      key: 'Agents',
      label: 'Agents',
      children: <AgentsPrompts />,
    },
    {
      key: 'Magicflow',
      label: 'Magicflow',
      children: <MagicflowPrompts />,
    },
  ];

  return (
    <div className="ml-2">
      <Tabs
        activeKey={activeSubTab}
        onChange={handleTabChange}
        items={tabItems}
        type="line"
      />
    </div>
  );
};

export default PromptsWrapper;
